var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/urls-management/calculateWidgetEnvUrl.ts
import { logger } from "@getvim/vim-connect-logger";

// src/constants.ts
var vimCommunicationModuleName = "Vim Communication";
var overrideEnvConfigQueryParamName = "overrideEnvConfig";

// src/types/moduleNames.ts
var ModuleNames = /* @__PURE__ */ ((ModuleNames4) => {
  ModuleNames4["Runtime"] = "vim-runtime";
  ModuleNames4["OrderAssistWidget"] = "order-assist";
  ModuleNames4["OrderAssistReferralsSelectButtonWidget"] = "order-assist-referrals-select-button";
  ModuleNames4["OrderAssistLabOrdersSelectButtonWidget"] = "order-assist-lab-orders-select-button";
  ModuleNames4["OrderAssistDIOrdersSelectButtonWidget"] = "order-assist-di-orders-select-button";
  ModuleNames4["OptumProWidget"] = "optum-pro";
  ModuleNames4["OptumDataCoreWidget"] = "optum-data-core";
  ModuleNames4["OptumDashboardWidget"] = "optum-data-core-dashboard";
  ModuleNames4["OptumReferralUtilityWidget"] = "optum-referral-utility";
  ModuleNames4["VimOSHub"] = "vim-os-hub-ui";
  ModuleNames4["VimConnectUIHubWidget"] = "vim-connect-ui-hub";
  ModuleNames4["VimConnectUITooltipWidget"] = "vim-connect-ui-tooltip";
  ModuleNames4["VimConnectUINotificationsWidget"] = "vim-connect-ui-notifications";
  ModuleNames4["MockCanvasAppWidget"] = "mock-canvas-app";
  return ModuleNames4;
})(ModuleNames || {});
var ServiceNames = /* @__PURE__ */ ((ServiceNames3) => {
  ServiceNames3["VimRuntime"] = "vim-runtime";
  ServiceNames3["WorkflowIntegration"] = "workflow-integration";
  ServiceNames3["VimOS"] = "connect";
  ServiceNames3["VimConnectUI"] = "vim-connect-ui";
  ServiceNames3["OrderAssist"] = "order-assist";
  ServiceNames3["Optum"] = "optum-referral-utility";
  ServiceNames3["OptumPro"] = "optum-pro";
  ServiceNames3["OptumDataCore"] = "optum-data-core";
  ServiceNames3["OptumDataCoreDashboard"] = "optum-data-core-dashboard";
  ServiceNames3["QualityGaps"] = "quality-gaps";
  ServiceNames3["DiagnosisGaps"] = "diagnosis-gaps";
  ServiceNames3["HealthHistory"] = "health-history";
  ServiceNames3["Eligibility"] = "eligibility";
  ServiceNames3["MockCanvasApp"] = "mock-canvas-app";
  ServiceNames3["FhirSimulator"] = "fhir-simulator";
  ServiceNames3["CDE"] = "cde";
  return ServiceNames3;
})(ServiceNames || {});
var moduleToServiceName = {
  ["vim-runtime" /* Runtime */]: "vim-runtime" /* VimRuntime */,
  ["order-assist" /* OrderAssistWidget */]: "order-assist" /* OrderAssist */,
  ["order-assist-referrals-select-button" /* OrderAssistReferralsSelectButtonWidget */]: "order-assist" /* OrderAssist */,
  ["order-assist-lab-orders-select-button" /* OrderAssistLabOrdersSelectButtonWidget */]: "order-assist" /* OrderAssist */,
  ["order-assist-di-orders-select-button" /* OrderAssistDIOrdersSelectButtonWidget */]: "order-assist" /* OrderAssist */,
  ["optum-pro" /* OptumProWidget */]: "optum-referral-utility" /* Optum */,
  ["optum-data-core" /* OptumDataCoreWidget */]: "optum-referral-utility" /* Optum */,
  ["optum-data-core-dashboard" /* OptumDashboardWidget */]: "optum-referral-utility" /* Optum */,
  ["optum-referral-utility" /* OptumReferralUtilityWidget */]: "optum-referral-utility" /* Optum */,
  ["vim-os-hub-ui" /* VimOSHub */]: "connect" /* VimOS */,
  ["vim-connect-ui-hub" /* VimConnectUIHubWidget */]: "vim-connect-ui" /* VimConnectUI */,
  ["vim-connect-ui-tooltip" /* VimConnectUITooltipWidget */]: "vim-connect-ui" /* VimConnectUI */,
  ["vim-connect-ui-notifications" /* VimConnectUINotificationsWidget */]: "vim-connect-ui" /* VimConnectUI */,
  ["mock-canvas-app" /* MockCanvasAppWidget */]: "mock-canvas-app" /* MockCanvasApp */
};

// src/urls-management/servicesConfigurations.ts
var serviceConfigs = {
  ["vim-runtime" /* VimRuntime */]: { localPort: 6022, proxy: "console" },
  ["workflow-integration" /* WorkflowIntegration */]: { localPort: 6002, proxy: "console" },
  ["order-assist" /* OrderAssist */]: { localPort: 3008 },
  ["mock-canvas-app" /* MockCanvasApp */]: { localPort: 3016, localApiPort: 3016 },
  ["connect" /* VimOS */]: { localPort: 7022 },
  ["vim-connect-ui" /* VimConnectUI */]: { localPort: 3004 },
  ["optum-referral-utility" /* Optum */]: { localPort: 3005 },
  ["quality-gaps" /* QualityGaps */]: { localApiPort: 6060 },
  ["eligibility" /* Eligibility */]: { localApiPort: 6070 },
  ["diagnosis-gaps" /* DiagnosisGaps */]: { localApiPort: 6080 },
  ["fhir-simulator" /* FhirSimulator */]: { localPort: 3018, localApiPort: 6055 },
  ["cde" /* CDE */]: { localPort: 3017 },
  ["health-history" /* HealthHistory */]: { localPort: 3007, localApiPort: 6090 }
};

// src/urls-management/getServiceUrlByEnv.ts
var getServiceWidgetUrlByEnv = (service, env) => {
  const serviceConfig = serviceConfigs[service];
  const { localPort, envToUrlOverrideMap, proxy } = serviceConfig != null ? serviceConfig : {};
  const serviceName = proxy != null ? proxy : service;
  return calculateServiceUrl({ serviceName, env, localPort, envToUrlOverrideMap });
};
var getServiceUrlByEnv = (service, env) => {
  var _a;
  const serviceConfig = serviceConfigs[service];
  const { localApiPort, envToUrlOverrideMap, proxy } = serviceConfig != null ? serviceConfig : {};
  const serviceName = proxy != null ? proxy : service;
  const localPort = localApiPort != null ? localApiPort : (_a = serviceConfigs["workflow-integration" /* WorkflowIntegration */]) == null ? void 0 : _a.localPort;
  return calculateServiceUrl({ serviceName, env, localPort, envToUrlOverrideMap });
};
var calculateServiceUrl = ({
  serviceName,
  env,
  localPort,
  envToUrlOverrideMap
}) => {
  const overrideEnvUrl = envToUrlOverrideMap == null ? void 0 : envToUrlOverrideMap[env];
  if (overrideEnvUrl) {
    return overrideEnvUrl;
  }
  switch (env) {
    case "local":
      if (!localPort) {
        throw new Error(`No local port defined for service ${serviceName}. }`);
      }
      return `http://localhost:${localPort}`;
    case "dev":
      return `https://${serviceName}.${env}.devim.io`;
    case "staging":
      return `https://${serviceName}.${env}.getvim.com`;
    case "demo":
      return `https://${serviceName}.${env}.getvim.com`;
    case "prod":
      return `https://${serviceName}.getvim.com`;
  }
};

// src/urls-management/calculateWidgetEnvUrl.ts
var scopedLogger = logger.scope("calculateWidgetEnvUrl");
var calculateWidgetEnvUrl = async (widgetId, overrideWidgetsConfig, {
  setOverridesConfigQueryParam = true,
  logger: providedLogger
} = {}) => {
  const serviceName = moduleToServiceName[widgetId] || widgetId;
  const logger4 = providedLogger != null ? providedLogger : scopedLogger;
  let widgetUrl = await getWidgetEnvUrl(serviceName, logger4, overrideWidgetsConfig);
  if (setOverridesConfigQueryParam && overrideWidgetsConfig) {
    const url = new URL(widgetUrl);
    url.searchParams.set(overrideEnvConfigQueryParamName, JSON.stringify(overrideWidgetsConfig));
    widgetUrl = url.href;
  }
  return widgetUrl;
};
var getWidgetEnvUrl = async (widgetId, logger4, overrideWidgetsConfig) => {
  var _a, _b;
  const widgetEnvOverride = (_a = overrideWidgetsConfig == null ? void 0 : overrideWidgetsConfig[widgetId]) == null ? void 0 : _a.widgetEnv;
  if (widgetEnvOverride) {
    const urlByWidgetEnvOverride = getServiceWidgetUrlByEnv(widgetId, widgetEnvOverride);
    logger4.info(
      `Widget "${widgetId}" calculated URL is [${urlByWidgetEnvOverride}] since an override widget config was provided`,
      { widgetEnv: widgetEnvOverride }
    );
    return urlByWidgetEnvOverride;
  }
  let widgetsEnv = (_b = window == null ? void 0 : window.$vim_environment) == null ? void 0 : _b.APP_ENV;
  if (!widgetsEnv) {
    logger4.warning(`Widget ${widgetId} failed to get env, using prod as default`);
    widgetsEnv = "prod";
  }
  const urlByDefaultEnv = getServiceWidgetUrlByEnv(widgetId, widgetsEnv);
  if (urlByDefaultEnv) {
    logger4.info(
      `Widget "${widgetId}" calculated URL is [${urlByDefaultEnv}] due to default widget env "${widgetsEnv}"`,
      {
        noPHI: true
      }
    );
    return urlByDefaultEnv;
  }
  throw new Error(
    `Could not find matching URL for widget [${widgetId}]! client configuration: ${JSON.stringify({
      widgetsEnv
    })}`
  );
};

// src/urls-management/calculateWidgetApiEnvUrl.ts
import { logger as logger2 } from "@getvim/vim-connect-logger";
var scopedLogger2 = logger2.scope("calculateWidgetApiEnvUrl");
var calculateWidgetApiEnvUrl = (widgetId, overrideWidgetsConfig) => {
  var _a;
  const serviceName = moduleToServiceName[widgetId] || widgetId;
  const widgetApiEnvOverride = (_a = overrideWidgetsConfig == null ? void 0 : overrideWidgetsConfig[widgetId]) == null ? void 0 : _a.apiEnv;
  if (widgetApiEnvOverride) {
    const urlByWidgetEnvOverride = getServiceUrlByEnv(serviceName, widgetApiEnvOverride);
    scopedLogger2.info(
      `Widget "${widgetId}" calculated API URL is [${urlByWidgetEnvOverride}] since an override API widget config was provided`,
      { widgetApiEnvOverride }
    );
    return urlByWidgetEnvOverride;
  }
};

// src/urls-management/modifyUrl.ts
import { logger as logger3 } from "@getvim/vim-connect-logger";
var scopedLogger3 = logger3.scope("modifyUrl", {
  moduleName: vimCommunicationModuleName,
  moduleAndScopeSameColor: true
});
var modifyUrl = (url, { path, clearQueryParams, queryParams } = {}) => {
  try {
    const sourceUrl = new URL(url);
    clearQueryParams && (sourceUrl.search = "");
    queryParams && Object.entries(queryParams).forEach(([key, value]) => sourceUrl.searchParams.set(key, value));
    if (path) {
      const basePath = sourceUrl.pathname !== "/" ? `${sourceUrl.pathname}/` : "";
      sourceUrl.pathname = `${basePath}${path}`;
    }
    return sourceUrl.href;
  } catch (error) {
    scopedLogger3.info(`Could not modify URL!`, {
      error,
      args: {
        url,
        options: { path, clearQueryParams, queryParams }
      }
    });
    return url;
  }
};

// src/types/environments.ts
var environments = ["local", "dev", "staging", "demo", "prod"];

// src/getProxiesByEnv.ts
import { uniqBy } from "lodash-es";
var getProxiesByEnv = async (_a) => {
  var _b = _a, { moduleNames } = _b, props = __objRest(_b, ["moduleNames"]);
  const services = moduleNames.map((moduleName) => {
    let proxyPath = "proxy.html";
    switch (moduleName) {
      case "vim-runtime" /* Runtime */: {
        proxyPath = "api/static/proxy.html";
        break;
      }
      case "vim-os-hub-ui" /* VimOSHub */: {
        proxyPath = "vim-os/proxy.html";
        break;
      }
    }
    return {
      serviceName: moduleToServiceName[moduleName],
      proxyPath
    };
  });
  const uniqServices = uniqBy(services, "serviceName");
  return await Promise.all(
    uniqServices.map(
      ({ serviceName, proxyPath }) => getServiceProxyUrlByEnv(__spreadProps(__spreadValues({}, props), { serviceName, proxyPath }))
    )
  );
};
var getServiceProxyUrlByEnv = async ({
  serviceName,
  proxyPath,
  overrideWidgetsConfig,
  logger: logger4
}) => {
  const serviceUrl = await calculateWidgetEnvUrl(serviceName, overrideWidgetsConfig, {
    setOverridesConfigQueryParam: false,
    logger: logger4
  });
  return modifyUrl(serviceUrl, { path: proxyPath, clearQueryParams: true });
};
export {
  ModuleNames,
  ServiceNames,
  calculateWidgetApiEnvUrl,
  calculateWidgetEnvUrl,
  environments,
  getProxiesByEnv,
  modifyUrl,
  moduleToServiceName,
  overrideEnvConfigQueryParamName,
  vimCommunicationModuleName
};
//# sourceMappingURL=index.js.map
